import React from 'react';

const AICallProvidersConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/ai-call-providers',
			component: React.lazy(() => import('./AICallProviders'))
		}
	]
};

export default AICallProvidersConfig;
